import axios from 'axios'
import Vue from 'vue'

let vm = new Vue()
const errorHandle = (status, msg, response) => {
	console.log(response)

	let output = {
		"title": 'Oops！系統出了一點問題',
		"type": "error"		
	}	
	switch (status) {
		case 400:
			console.log(status)
			break;
		case 401:
			localStorage.removeItem('merchant_session')
			break;
		
		case 404:
			break;			
		case 500:
			console.log('API出事惹QAQ')
			break;

		case 502:
			console.log('應該是在部署程式')
			// vm.$alert(output)
			break;


		default:
			console.log('攔不到錯誤QQ')
	}
}

var instance = axios.create({
	// baseURL: 'https://httpstat.us/500',
	baseURL: process.env.VUE_APP_API_ENDPOINT,
})

instance.interceptors.request.use(
	(config) => {
		let admin_session = localStorage.getItem('merchant_session')
		let token = 'Bearer reservation_merchant.reservation_merchant1805'
		if (admin_session !== null){
			admin_session = JSON.parse(admin_session)
			token += '.' + admin_session.user_id + '.' + admin_session.token
		}
		else {
			token += '..'
		}
		config.headers.Authorization = token;
		// config.url = 'https://spaapi-staging.shopping99.com/api/ticket/server/error'
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

instance.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		const { response } = error;

		if (response) {
			errorHandle(response.status, response.data.error, response);
		}

		return Promise.reject(error);
	}
);

export default function(method, url, data=null) {
	method = method.toLowerCase();

	switch (method) {
		case 'get':
			return instance.get(url, {params: data})

		case 'post':
			return instance.post(url, data)

		case 'put':
			return instance.put(url, data)

		case 'delete':
			return instance.delete(url, {params: data})

		default:
			console.error('unknown_request_method' + method)
			return false
	}
}
